import { getWindow } from 'src/utilities/window';

export const GROUPADMIN_ADMIN_BASE_PATH = '/groupadmin/admin';

export const DINER_WEB_INSTACART_GROCERY_PATH =
  '/third-party/grocery?partner=instacart';

export enum CAUIPage {
  EMPLOYEES = 'EMPLOYEES',
  EMPLOYEE_DETAILS = 'EMPLOYEE_DETAILS',
  EMPLOYEES_UPLOAD = 'EMPLOYEES_UPLOAD',
  EXPENSE_CODES = 'EXPENSE_CODES',
  EXPENSE_REASONS = 'EXPENSE_REASONS',
  GROUP_ORDERS = 'GROUP_ORDERS',
  GROUP_ORDERS_CREATE = 'GROUP_ORDERS_CREATE',
  ORDERING_POLICY = 'ORDERING_POLICY',
  ADMINS = 'ADMINS',
}

interface CAUIUrlParams {
  corpId?: string;
  employeeId?: string;
}

const getCAUIPath = (page: CAUIPage, employeeId?: string): string => {
  const basePath = GROUPADMIN_ADMIN_BASE_PATH;

  switch (page) {
    case CAUIPage.EMPLOYEES:
      return `${basePath}/employees`;
    case CAUIPage.EMPLOYEE_DETAILS:
      return `${basePath}/employees/details/${employeeId}`;
    case CAUIPage.EMPLOYEES_UPLOAD:
      return `${basePath}/employees/upload`;
    case CAUIPage.EXPENSE_CODES:
      return `${basePath}/expense-codes`;
    case CAUIPage.EXPENSE_REASONS:
      return `${basePath}/expense-reasons`;
    case CAUIPage.GROUP_ORDERS:
      return `${basePath}/group-orders`;
    case CAUIPage.GROUP_ORDERS_CREATE:
      return `${basePath}/group-orders/create`;
    case CAUIPage.ORDERING_POLICY:
      return `${basePath}/ordering-policy`;
    case CAUIPage.ADMINS:
      return `/groupadmin/admins`;
    default:
      return basePath;
  }
};

export const buildCAUIPath = (
  page: CAUIPage,
  params?: CAUIUrlParams
): string => {
  const { corpId, employeeId } = params || {};
  const path = getCAUIPath(page, employeeId);

  if (corpId) {
    return `${path}?corpId=${corpId}`;
  }

  return path;
};

export const buildCAUIUrl = (page: CAUIPage, params: CAUIUrlParams): string => {
  const window = getWindow();
  return `${window.location.origin}${buildCAUIPath(page, params)}`;
};

export const CMUI_BASE_PATH = '/corporate/enterprise';

export enum CMUIPage {
  HOME = 'HOME',
  EMPLOYEES = 'EMPLOYEES',
  EMPLOYEE_CREATE = 'EMPLOYEE_CREATE',
  EMPLOYEE_DETAILS = 'EMPLOYEE_DETAILS',
  REPORTS = 'REPORTS',
  GROCERIES = 'GROCERIES',
}

interface CMUIUrlParams {
  corpId: string;
  employeeId?: string;
}

const getCMUIPath = (page: CMUIPage, params: CMUIUrlParams): string => {
  const { corpId, employeeId } = params;
  const basePath = `${CMUI_BASE_PATH}/${corpId}`;

  switch (page) {
    case CMUIPage.EMPLOYEES:
      return `${basePath}/employees`;
    case CMUIPage.EMPLOYEE_CREATE:
      return `${basePath}/employees/create`;
    case CMUIPage.EMPLOYEE_DETAILS:
      return `${basePath}/employees/${employeeId}/details`;
    case CMUIPage.REPORTS:
      return `${basePath}/reports`;
    case CMUIPage.GROCERIES:
      return `${basePath}/groceries`;
    case CMUIPage.HOME:
    default:
      return `${basePath}/home`;
  }
};

export const buildCMUIPath = (
  page: CMUIPage,
  params: CMUIUrlParams
): string => {
  return getCMUIPath(page, params);
};

export const buildCMUIUrl = (page: CMUIPage, params: CMUIUrlParams): string => {
  const window = getWindow();
  return `${window.location.origin}${buildCMUIPath(page, params)}`;
};

export interface HomeBreadcrumbConfig {
  href: string;
  useRouterLink: boolean;
}

export const getHomePath = (corpId: string): string => {
  return buildCMUIPath(CMUIPage.HOME, { corpId });
};

export const getHomeBreadcrumb = (corpId: string): HomeBreadcrumbConfig => {
  return {
    href: buildCMUIPath(CMUIPage.HOME, { corpId }),
    useRouterLink: true,
  };
};

export const getHomeUrl = (corpId: string): string => {
  return buildCMUIUrl(CMUIPage.HOME, { corpId });
};
